module.exports = __webpack_public_path__ + "img/info.cb8f12c6.png";